import { cloneElement, ReactElement } from 'react';
import { NestedTableLeafProps } from '../types';

export const Leaf = ({ value, color, path, depth, isActive }: NestedTableLeafProps) => {
  return (
    <>
      {cloneElement(value as ReactElement, {
        ...(value as ReactElement).props,
        path,
        color,
        depth,
        isActive,
      })}
    </>
  );
};
